const relations = [
    { value: 'Mother', name: 'Mother' },
    { value: 'Father', name: 'Father' },
    { value: 'Sibling', name: 'Sibling' },
    { value: 'Spouse', name: 'Spouse' },
    { value: 'Child', name: 'Child' },
    { value: 'Friend', name: 'Friend' },
    { value: 'Cousin', name: 'Cousin' },
    { value: 'Grandparent', name: 'Grandparent' },
    { value: 'Grandchild', name: 'Grandchild' },
    { value: 'Uncle', name: 'Uncle' },
    { value: 'Aunt', name: 'Aunt' },
    { value: 'Nephew', name: 'Nephew' },
    { value: 'Niece', name: 'Niece' },
    { value: 'Partner', name: 'Partner' },
    { value: 'Colleague', name: 'Colleague' },
    { value: 'Acquaintance', name: 'Acquaintance' },
    { value: 'Neighbor', name: 'Neighbor' },
    { value: 'Mentor', name: 'Mentor' },
    { value: 'Mentee', name: 'Mentee' },
    { value: 'Step-parent', name: 'Step-parent' },
    { value: 'Step-sibling', name: 'Step-sibling' }
];


export  default relations